import actions from "./actions";

const {
  GET_DATA_PROYECTS,
  GET_DATA_BEGIN,
  GET_DATA_FINISH,
  SET_DATA_PROYECTS,
  SET_DATA_NEW_PROYECT,
  SET_PROYECT_NAME,
} = actions;

const initialState = {
  data: [],
  total: 0,
  totalPages: 0,
  page: 0,
  loading: false,
  proyectName: "",
};

const proyectsReducer = (state = initialState, action: any) => {
  const { type, data } = action;
  switch (type) {
    case GET_DATA_PROYECTS:
      return {
        ...state
      };
    case GET_DATA_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_DATA_FINISH:
      return {
        ...state,
        loading: false,
      };
    case SET_DATA_PROYECTS:
      return {
        ...state,
        data: data.results,
        total: data.totalResults,
        totalPages: data.totalPages,
        page: data.page,
        loading: false,
      };
    case SET_DATA_NEW_PROYECT:
      return {
        ...state,
        data: [data, ...state.data],
      };
    case SET_PROYECT_NAME:
      return {
        ...state,
        proyectName: data,
      };
    default:
      return state;
  }
};
export { proyectsReducer };
